import { JobEngagementFunnel } from "../../types";
import { JobEngagementFunnelResponse } from "../controllers/jobs";

export const convertJobEngagementFunnelResponse = (
    jobEngagementFunnelResponse: JobEngagementFunnelResponse
): JobEngagementFunnel => {
    const result: JobEngagementFunnel = {
        totalVisits: jobEngagementFunnelResponse.totalVisits,
        totalUniqueVisits: jobEngagementFunnelResponse.totalUniqueVisits,
        totalFavorites: jobEngagementFunnelResponse.totalFavorites,
    };

    return result;
};
